import { render, staticRenderFns } from "./ComboEtapaLead.vue?vue&type=template&id=03133b96"
import script from "./ComboEtapaLead.vue?vue&type=script&lang=ts"
export * from "./ComboEtapaLead.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports